import { Spacing } from '@persona-id/design-tokens';
import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react';

import { TableHeaderCell } from 'design-system/components/Table';
import { HelperTooltip } from 'design-system/components/Tooltip';

interface TableTHProps extends ComponentPropsWithoutRef<typeof TableHeaderCell> {
  canSort?: boolean;
  isSorted?: boolean;
  isDescending?: boolean;
  isSticky?: boolean;
  /**
   * Display help icon and tooltip for column header
   */
  helpText?: ReactNode;
}

const TableTH = forwardRef<HTMLTableCellElement, TableTHProps>(function TableTH(
  { children, canSort, isSorted, isSticky, isDescending, helpText, ...props },
  ref,
) {
  return (
    <TableHeaderCell
      sortable={canSort}
      sortDirection={canSort && isSorted ? (isDescending ? 'desc' : 'asc') : false}
      ref={ref}
      isSticky={isSticky}
      {...props}
    >
      {/* We have to wrap the children to make it easier to use tooltips with Pendo */}
      <span className='th__text'>{children}</span>
      {helpText && (
        <HelperTooltip size='sm' css={{ height: 14, marginLeft: Spacing[1] }}>
          {helpText}
        </HelperTooltip>
      )}
    </TableHeaderCell>
  );
});

export default TableTH;
